// export const API_URL =
//   process.env.NEXT_PUBLIC_API_URL || 'http://localhost:1337';


export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'https://uriewklj.softmouse.net';
export const REACT_PUBLIC_STRAPI_API_TOKEN =
  'f81ea19c705243456ec719acf87c61a0478e638b395886f719ad98ffaefdb4707298d9b1cc0b59531aba8eceef3147c1c81e7870386810ec69ac9698db8c7e77c6da0239ebf2eef84f15766964fd419d77721373ba6d4c72c974e8b2f915ef17ad9d370dc85c273135c25ad4025609d7552d59dea810c43685a0a99360d8b90f';
export const REACT_RECAPTCHA_SITE_KEY =
  '6Lf5Oz0rAAAAAD1LGD6F19xT2UlYxG4mjwoe4QJ3';